import { useState } from "react";
import Button from "../common/Button";
import { Filter, RotateCcw } from "lucide-react";

const TaskFilters = ({ onFilter }) => {
  const [filters, setFilters] = useState({ status: "", priority: "" });

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const applyFilters = () => {
    onFilter(filters);
  };

  const resetFilters = () => {
    const empty = { status: "", priority: "" };
    setFilters(empty);
    onFilter(empty);
  };

  return (
    <div className="bg-white rounded-xl border border-gray-100 p-4 shadow-sm mb-6">
      <div className="flex flex-wrap items-end gap-4">
        <div>
          <label className="block text-xs font-medium text-gray-500 mb-1">Status</label>
          <select
            name="status"
            value={filters.status}
            onChange={handleChange}
            className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500"
          >
            <option value="">All Status</option>
            <option value="pending">Pending</option>
            <option value="completed">Completed</option>
          </select>
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-500 mb-1">Priority</label>
          <select
            name="priority"
            value={filters.priority}
            onChange={handleChange}
            className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500"
          >
            <option value="">All Priorities</option>
            <option value="high">High</option>
            <option value="medium">Medium</option>
            <option value="low">Low</option>
          </select>
        </div>
        <Button onClick={applyFilters} size="md">
          <Filter className="w-4 h-4 mr-1.5" />
          Filter
        </Button>
        <Button onClick={resetFilters} variant="ghost" size="md">
          <RotateCcw className="w-4 h-4 mr-1.5" />
          Reset
        </Button>
      </div>
    </div>
  );
};

export default TaskFilters;
